<template>
    <div class="common-seach-wrap">

        <el-tabs size="small" type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.value" :name="item.key" ></el-tab-pane>
        </el-tabs>

        <!--心愿列表-->
        <List v-if="activeName === 'list'" />
        <!--心愿类别-->
        <Category v-if="activeName === 'category'" />
        <!--领取记录-->
        <Claim v-if="activeName === 'claim'" />

    </div>
</template>
<script>
    import bus from '@/utils/eventBus.js';
    import List from './wish/index';
    import Category from './category/index';
    import Claim from './claim/index';
    export default {
        components: {
            List,
            Category,
            Claim,
        },
        data() {
            return {
                /*当前选中*/
                activeName: 'list',
                /*切换数组原始数据*/
                sourceList: [
                    {
                        key: 'list',
                        value: '心愿列表',
                        path:'/education/wish/index'
                    },
                    {
                        key: 'claim',
                        value: '认领记录',
                        path:'/education/wish/claim'
                    },
                    {
                        key: 'category',
                        value: '心愿类别',
                        path:'/education/wish/categoryList'
                    },
                ],
                /*权限筛选后的数据*/
                tabList:[],
            };
        },
        created() {
            this.tabList=this.authFilter();

            if (this.$route.query.type != null) {
                this.activeName = this.$route.query.type;
            }

        },

        methods: {

            handleClick(e) {
                this.activeName = e.name;
            },

            /*权限过滤*/
            authFilter(){
                let list=[];
                for(let i=0;i<this.sourceList.length;i++){
                    let item=this.sourceList[i];
                    if(this.$filter.isAuth(item.path)){
                        list.push(item);
                    }
                }
                return list;
            },

        }
    };
</script>

<style>
    .operation-wrap {
        height: 124px;
        border-radius: 8px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 30px 30px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        overflow: hidden;
        background: #909399;
        background-size: 100% 100%;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/wish/index.vue